import * as React from "react";
import { A, D, pipe } from "@mobily/ts-belt";
import { useSigningAssistant } from "./signingAssistant";

export default function useUnsignedCount(route) {
  const unsignedCountRef = React.useRef(null);
  const intervals = React.useRef([]);

  const { data: newSalesData } = useSigningAssistant({
    route,
    includeCancelledOrders: true,
  });

  const [unsignedCount, setUnsignedCount] = React.useState(0);

  React.useEffect(() => {
    const tempUnsignedCount = pipe(
      newSalesData ?? {},
      D.values,
      A.reduce(0, (acc, cv) => acc + (cv.totalSales - cv.totalSigned)),
    );

    setUnsignedCount((prevState = 0) => {
      if (prevState < tempUnsignedCount) {
        if (unsignedCountRef.current) {
          unsignedCountRef.current.classList.add("flash");
          intervals.current.push(
            setTimeout(() => {
              if (unsignedCountRef.current) {
                unsignedCountRef.current.classList.remove("flash");
              }
            }, 1100),
          );
        }
      }
      return tempUnsignedCount;
    });
  }, [newSalesData]);

  React.useEffect(() => {
    const currentIntervals = intervals.current;
    return () => {
      for (const interval of currentIntervals) {
        clearTimeout(interval);
      }
    };
  }, []);

  return { unsignedCount, unsignedCountRef };
}
